import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { routes } from "../routes"

export default function Footer() {
    const { t } = useTranslation()

    const links = [
        {
            title: t("Privacy Policy"),
            to: routes.privacyPolicy.index
        },
        {
            title: t("Terms and Conditions"),
            to: routes.termsAndConditions.index
        },
        {
            title: t("FAQ"),
            to: routes.faq.index
        },
        {
            title: t("Contact"),
            to: routes.contact.index
        }
    ]

    return (
        <footer className="w-full bg-white">
            <div className="py-8 sm:pb-24 px-6 sm:px-3">
                <div className="flex w-full justify-between sm:justify-center items-center gap-4 sm:gap-12 text-lg sm:text-base">
                    {links.map(({ title, to }, index) => (
                        <Link key={index} to={to} className="text-slate-900 duration-200 transition hover:text-slate-300 font-light text-center">{title}</Link>
                    ))}
                </div>
            </div>
        </footer>
    )
}